import {Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';
import {Tab} from '../tab.model';
import {TabContainerData} from '../tab-container-data';
import {TabStyles} from '../tab-styles';

@Component({
  selector: 'spb-open-tabs',
  templateUrl: './open-tabs.component.html',
})
export class OpenTabsComponent implements OnInit {
  @Input() tabContainerData: TabContainerData[];
  @Input() tabsToShow: Tab[];
  @Input() tabStyles: TabStyles;
  @Output() onTabSelection: EventEmitter<any> = new EventEmitter();
  @HostBinding('class.spb-open-tabs') hostBaseClass = true;

  constructor() {
  }

  ngOnInit() {
  }

}
